export enum PriceRuleType {
    None = 0,
    TimeOfADayPriceRule = 1,
    HoursBookedPriceRule = 2,
    ParticipantPriceRule = 3,
}